<template>
    <script type="application/ld+json" v-html="jsonLd"></script>
</template>

<script>
export default {
    props: {
        jsonLd: {
            type: String,
            required: true,
        },
    },
};
</script>
